export function getUrl() {
    return new URL(window.location.href);
}
export function getQueryParameter(key) {
    const value = getUrl().searchParams.get(key);
    // URLSearchParams.get returns string | null, but our codebase tends to avoid the use of null.
    // Instead of returning null, we return undefined.
    if (value === null) {
        return undefined;
    }
    return value;
}
export function setQueryParameter(...args) {
    const url = getUrl();
    let params = [];
    let replace = false;
    if (typeof args[0] === "string" && typeof args[1] === "string") {
        // Implementation for setQueryParameter(key: string, value: string)
        params = [[args[0], args[1]]];
        if (typeof args[2] === "boolean") {
            replace = args[2];
        }
    }
    else if (Array.isArray(args[0])) {
        // Implementation for setQueryParameter(params: QueryParameter[])
        params = args[0];
        if (typeof args[1] === "boolean") {
            replace = args[1];
        }
    }
    params.forEach(([key, value]) => {
        if (value === "") {
            url.searchParams.delete(key);
        }
        else {
            url.searchParams.set(key, value);
        }
    });
    updateUrl(url, replace);
}
export function deleteQueryParameter(key, replace = false) {
    const url = getUrl();
    url.searchParams.delete(key);
    updateUrl(url, replace);
}
export function updateUrl(url, replace = false) {
    if (replace) {
        history.replaceState({}, document.title, url.href);
    }
    else {
        history.pushState({}, document.title, url.href);
    }
}
/**
 * Checks if the supplied string is a valid HTTP url structure.
 * @param url
 */
export function isValidURL(url) {
    try {
        const urlObject = new URL(url);
        return urlObject.protocol === "http:" || urlObject.protocol === "https:";
    }
    catch (err) {
        // attempt to fix the URL by prefixing it with protocol if it's missing
        if (url.slice(0, 5) !== "http:" && url.slice(0, 6) !== "https:") {
            url = `https://${url}`;
            // retest
            try {
                return Boolean(new URL(url));
            }
            catch (err) {
                return false;
            }
        }
    }
    return false;
}
/**
 * Checks if the supplied string is a valid wpt url script.
 * @param script
 */
export function isValidScript(script) {
    if (!script) {
        return { valid: true, message: "No script present." };
    }
    else {
        //If a script exists it must contain at least one navigate.
        const scriptLines = script.split("\n");
        const scriptLinesWithNavigateCommand = [];
        const scriptContainsNavigate = scriptLines.some((line) => {
            const containsNavigate = line.match(/^\s*navigate\s+/);
            if (containsNavigate) {
                scriptLinesWithNavigateCommand.push(line);
                return true;
            }
            else {
                return false;
            }
        });
        if (!scriptContainsNavigate) {
            return {
                valid: false,
                message: "Script must include a valid “navigate” command.",
            };
        }
        else {
            let validNavigate = false;
            //Are the supplied navigate commands valid.
            scriptLinesWithNavigateCommand.forEach((line) => {
                if (line.search(/navigate\t+http/) !== -1 ||
                    line.search(/navigate\t+%url%/) !== -1 ||
                    line.search(/navigate\t+%URL%/) !== -1 ||
                    line.search(/navigate\t+%ORIGIN%/) !== -1 ||
                    line.search(/navigate\t+%origin%/) !== -1 ||
                    line.search(/navigate\x20+http/) !== -1 ||
                    line.search(/navigate\x20+%url%/) !== -1 ||
                    line.search(/navigate\x20+%URL%/) !== -1 ||
                    line.search(/navigate\x20+%ORIGIN%/) !== -1 ||
                    line.search(/navigate\x20+%origin%/) !== -1) {
                    validNavigate = true;
                }
            });
            if (validNavigate) {
                return {
                    valid: true,
                    message: "Script includes valid navigate command.",
                };
            }
            else {
                return {
                    valid: false,
                    message: "Script must include a valid “navigate” command.",
                };
            }
        }
    }
}
